export const defaultFlagSearch = {
	isSearchWithDynamicAndStaticData: true
}
